<template>
  <el-dialog :title="$t('addAGoodsMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addAGoodsMenuInfo" label-width="120px">
      <el-form-item :label="$t('addAGoodsMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addAGoodsMenu.menuNameRequired') }]">
        <el-input v-model="addAGoodsMenuInfo.hktName" :placeholder="$t('addAGoodsMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addAGoodsMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addAGoodsMenuInfo.hktDesc" :placeholder="$t('addAGoodsMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.label')" prop="label">
        <el-input v-model="addAGoodsMenuInfo.label" :placeholder="$t('addAGoodsMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.selectGoods')" required>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="shopId" :rules="[{ required: true, message: $t('addAGoodsMenu.shopRequired') }]">
              <el-select v-model="addAGoodsMenuInfo.shopId" :placeholder="$t('addAGoodsMenu.selectShop')"
                style="width:100%" @change="queryAShopGoods">
                <el-option :label="$t('addAGoodsMenu.selectShop')" value="" />
                <el-option v-for="shop in addAGoodsMenuInfo.shops" :key="shop.shopId" :label="shop.shopName"
                  :value="shop.shopId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="productId" :rules="[{ required: true, message: $t('addAGoodsMenu.goodsRequired') }]">
              <el-select v-model="addAGoodsMenuInfo.productId" :placeholder="$t('addAGoodsMenu.selectGoods')"
                style="width:100%">
                <el-option :label="$t('addAGoodsMenu.selectGoods')" value="" />
                <el-option v-for="product in addAGoodsMenuInfo.products" :key="product.productId"
                  :label="product.prodName" :value="product.productId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addAGoodsMenu.sortRequired') }]">
        <el-input v-model="addAGoodsMenuInfo.seq" :placeholder="$t('addAGoodsMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addAGoodsMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addAGoodsMenu.showStatusRequired') }]">
        <el-select v-model="addAGoodsMenuInfo.isShow" :placeholder="$t('addAGoodsMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAddAGoodsMenuInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu, queryShopsByAdmin, queryProduct } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddAGoodsMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addAGoodsMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '1',
        isShow: '',
        typeCd: '2002',
        shopId: '',
        shops: [],
        products: [],
        productId: ''
      }
    }
  },
  methods: {
    open(data = {}) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.addAGoodsMenuInfo = {
          ...this.addAGoodsMenuInfo,
          ...data
        }
        if (data.hktIcon) {
          this.$refs.uploadImage.setImages([data.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }
        this.loadShops()
      })
    },
    async loadShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.addAGoodsMenuInfo.shops = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async queryAShopGoods() {
      if (!this.addAGoodsMenuInfo.shopId) return

      try {
        const res = await queryProduct({
          page: 1,
          row: 500,
          shopId: this.addAGoodsMenuInfo.shopId
        })
        this.addAGoodsMenuInfo.products = res.data
        this.addAGoodsMenuInfo.productId = ''
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadImage(photos) {
      this.addAGoodsMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveAddAGoodsMenuInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addAGoodsMenuInfo.url = `/pages/goods/goods?productId=${this.addAGoodsMenuInfo.productId}&shopId=${this.addAGoodsMenuInfo.shopId}`

        await saveProductMenu(this.addAGoodsMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>